// ============= Environment =============

export const SIGNALR_BASE_URL = import.meta.env.VITE_BASE_CORE_URL;
export const LITIUM_SCOPE = import.meta.env.VITE_LITIUM_CORE_SCOPE;

export const ASK_RELAY_HUB_PATH = import.meta.env
  .VITE_SIGNALR_HUB_PATH_ASK_RELAY_HUB;
export const USER_RELAY_HUB_PATH = import.meta.env
  .VITE_SIGNALR_HUB_PATH_USER_RELAY_HUB;
export const WORKSPACE_RELAY_HUB_PATH = import.meta.env
  .VITE_SIGNALR_HUB_PATH_WORKSPACE_RELAY_HUB;

export const SIGNALR_ENABLED_STATE = import.meta.env.VITE_ENABLE_SIGNALR;
export const USE_PROXY = import.meta.env.VITE_SIGNALR_USE_PROXY;

const isDevelopment = import.meta.env.DEV;
const shouldUseProxy =
  isDevelopment && USE_PROXY !== 'false' && USE_PROXY !== '0';

/** Relative path in dev (Vite proxy) or full base URL in production. */
export const getSignalRBaseUrl = (): string => {
  if (shouldUseProxy) {
    return '';
  }
  return SIGNALR_BASE_URL || '';
};

/** Defaults to true when VITE_ENABLE_SIGNALR is not explicitly false. */
export const IS_SIGNALR_ENABLED =
  SIGNALR_ENABLED_STATE !== 'false' && SIGNALR_ENABLED_STATE !== '0';

export const MANUAL_PING_INTERVAL_MS = 60_000;
export const SOCKET_INTERCEPT_DELAY_MS = 2_000;
export const MANUAL_PING_START_DELAY_MS = 2_500;
export const RECONNECT_RETRY_DELAY_MS = 5_000;
export const SOCKET_UPDATE_AFTER_RECONNECT_MS = 1_000;
